import styled, { css } from "styled-components";

interface AlertTemplateStyleProps {
  $alert?: boolean;
}

export const AlertTemplate = styled.div<AlertTemplateStyleProps>`
  gap: 16px;
  width: 100vw;
  height: 100svh;
  display: grid;
  padding: 16px;
  background: ${(props) => props.theme.colors.primary100};
  grid-template-rows: 1fr 56px;

  ${(props) =>
    props.$alert &&
    css`
      background: ${(props) => props.theme.colors.white100};
    `}
`;

export const AlertContent = styled.section`
  display: flex;
  align-items: center;
  justify-content: center;
`;
